import { ChainId } from '@pancakeswap/sdk'

export const SUPPORT_ONLY_BSC = [ChainId.IGRA, ChainId.KASPLEX_TESTNET, ChainId.KASPLEX_MAINNET]
export const SUPPORT_FARMS = [ChainId.KASPLEX_TESTNET, ChainId.KASPLEX_MAINNET]
